import { createReducer, on } from '@ngrx/store';
import { CardType, OrganizationPaymentAccount } from '@uzurv/clara';
import * as MobilityManagerActions from './mobility-manager.actions';

export interface MobilityManagerState {
  organizationPaymentAccounts: Array<OrganizationPaymentAccount>;
  isSubmitting: boolean;
  cardTypes: Array<CardType>;
  hasOpenedNoPaymentAccountsDialog?: boolean;
  hasOpenedExpiredPaymentAccountsDialog?: boolean;
}

export const mobilityManagerFeatureKey = 'mobility-manager';

export const mobilityManagerInitialState: MobilityManagerState = {
  organizationPaymentAccounts: [],
  isSubmitting: false,
  cardTypes: [],
  hasOpenedNoPaymentAccountsDialog: false,
  hasOpenedExpiredPaymentAccountsDialog: false
};

export const mobilityManagerReducer = createReducer(
  mobilityManagerInitialState,
  on(
    MobilityManagerActions.GetOrganizationPaymentAccounts,
    MobilityManagerActions.CreateOrganizationPaymentAccount,
    MobilityManagerActions.EditOrganizationPaymentAccount,
    MobilityManagerActions.DeleteOrganizationPaymentAccount,
    MobilityManagerActions.SetDefaultOrganizationPaymentAccount,
    state => {
      return {
        ...state,
        isSubmitting: true
      };
    }
  ),
  on(
    MobilityManagerActions.GetOrganizationPaymentAccountSuccess,
    MobilityManagerActions.CreateOrganizationPaymentAccountSuccess,
    MobilityManagerActions.CreateOrganizationPaymentAccountFail,
    MobilityManagerActions.EditOrganizationPaymentAccountSuccess,
    MobilityManagerActions.EditOrganizationPaymentAccountFail,
    MobilityManagerActions.DeleteOrganizationPaymentAccountSuccess,
    MobilityManagerActions.DeleteOrganizationPaymentAccountFail,
    MobilityManagerActions.SetDefaultOrganizationPaymentAccountSuccess,
    MobilityManagerActions.SetDefaultOrganizationPaymentAccountFail,
    MobilityManagerActions.OpenAddOrganizationPaymentAccountDialog,
    state => {
      return {
        ...state,
        isSubmitting: false
      };
    }
  ),
  on(MobilityManagerActions.GetOrganizationPaymentAccountSuccess, (state, action) => {
    return {
      ...state,
      organizationPaymentAccounts: action.organizationPaymentAccounts
    };
  }),
  on(MobilityManagerActions.GetCardTypesSuccess, (state, action) => {
    return {
      ...state,
      cardTypes: action.cardTypes
    };
  }),
  on(MobilityManagerActions.OpenOrganizationPaymentAccountNeededDialog, state => {
    return {
      ...state,
      hasOpenedNoPaymentAccountsDialog: true
    };
  }),
  on(MobilityManagerActions.OpenDefaultOrganizationPaymentAccountExpiredDialog, state => {
    return {
      ...state,
      hasOpenedExpiredPaymentAccountsDialog: true
    };
  }),
  on(MobilityManagerActions.Close, state => {
    return {
      ...state,
      organizationPaymentAccounts: [],
      hasOpenedNoPaymentAccountsDialog: false,
      hasOpenedExpiredPaymentAccountsDialog: false
    };
  })
);
